import { forwardRef } from 'react';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path d='M12.75 0C8.18893 0 4.5 3.756 4.5 8.4C4.5 13.044 12.75 24 12.75 24C12.75 24 21 13.044 21 8.4C21 3.756 17.3111 0 12.75 0ZM12.75 20.4C12.75 20.4 6.85714 12 6.85714 8.4C6.85714 5.088 9.49714 2.4 12.75 2.4C16.0029 2.4 18.6429 5.088 18.6429 8.4C18.6429 12 12.75 20.4 12.75 20.4ZM15.1071 8.664C15.1071 9.984 14.0464 11.064 12.75 11.064C11.4536 11.064 10.3929 9.984 10.3929 8.664C10.3929 7.344 11.4536 6.264 12.75 6.264C14.0464 6.264 15.1071 7.332 15.1071 8.664Z' />
        </SvgIcon>
    );
});
